// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventory-tree-toolbar {
  padding: 12px 20px;
  border-bottom: 1px solid #e5e7eb;
}
.inventory-tree-toolbar .tree-search-input,
.inventory-tree-toolbar input {
  max-width: 280px;
}

.inventory-tree {
  padding: 16px 20px;
}

.tree-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.inventory-tree-node .tree-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 12px;
  cursor: pointer;
  transition: background 0.15s;
  border-radius: 6px;
  min-height: 32px;
}
.inventory-tree-node .tree-row:hover {
  background: rgba(0, 0, 0, 0.03);
}
.inventory-tree-node .tree-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  flex-shrink: 0;
  color: #6b7280;
}
.inventory-tree-node .tree-toggle .tree-spacer {
  width: 16px;
  display: inline-block;
}
.inventory-tree-node .tree-icon {
  flex-shrink: 0;
  color: #6b7280;
}
.inventory-tree-node .tree-icon.tree-icon-folder {
  color: #6b7280;
}
.inventory-tree-node .tree-icon.tree-icon-leaf {
  color: #2563eb;
  opacity: 1;
}
.inventory-tree-node .tree-icon.tree-icon-assembly {
  color: #7c3aed;
}
.inventory-tree-node .tree-icon.tree-icon-model {
  color: #0f766e;
}
.inventory-tree-node .tree-icon.tree-icon-final-product {
  color: #d97706;
}
.inventory-tree-node .tree-icon-assembly-input {
  color: #a855f7;
}
.inventory-tree-node .tree-model-badge {
  margin-left: 8px;
  font-size: 10px;
  font-weight: 600;
  font-family: monospace;
  color: #0f766e;
  background: rgba(15, 118, 110, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
}
.inventory-tree-node .tree-model-hub-badge {
  margin-left: 8px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #0f766e;
  background: rgba(15, 118, 110, 0.12);
  padding: 2px 6px;
  border-radius: 4px;
}
.inventory-tree-node .tree-final-product-badge {
  margin-left: 8px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #d97706;
  background: rgba(217, 119, 6, 0.12);
  padding: 2px 6px;
  border-radius: 4px;
}
.inventory-tree-node .tree-assembly-badge {
  margin-left: 8px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #7c3aed;
  background: rgba(124, 58, 237, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
}
.inventory-tree-node .tree-label {
  flex: 1 1;
  min-width: 0;
  font-size: 14px;
  color: #111827;
}
.inventory-tree-node .tree-composition {
  margin-left: 4px;
  font-size: 12px;
  color: #9ca3af;
}
.inventory-tree-node .tree-inputs-badge {
  font-size: 11px;
  color: #6b7280;
  background: #f3f4f6;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 6px;
}
.inventory-tree-node .tree-count {
  font-size: 14px;
  color: #6b7280;
  margin-left: 4px;
  min-width: 24px;
  text-align: right;
}
.inventory-tree-node .tree-count--empty {
  opacity: 0.65;
}
.inventory-tree-node .tree-machine-badges {
  display: flex;
  gap: 4px;
  margin-left: 8px;
  flex-shrink: 0;
}
.inventory-tree-node .tree-machine-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-family: monospace;
  color: #3b82f6;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  padding: 1px 6px;
  border-radius: 4px;
  white-space: nowrap;
}
.inventory-tree-node .tree-qty-used {
  font-size: 12px;
  color: #9ca3af;
  margin-left: 4px;
  font-weight: 500;
}
.inventory-tree-node .tree-row-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  flex-shrink: 0;
}
.inventory-tree-node .tree-weight,
.inventory-tree-node .tree-cycle {
  font-size: 0.72rem;
  font-weight: 600;
  color: #475569;
  white-space: nowrap;
  padding: 2px 8px;
  background: #f1f5f9;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}
.inventory-tree-node .tree-cycle {
  color: #1d4ed8;
  background: #eff6ff;
  border-color: #bfdbfe;
}
.inventory-tree-node .tree-weight-wastage {
  opacity: 0.75;
  font-size: 0.9em;
  color: var(--m-danger-color, #dc3545);
}
.inventory-tree-node .tree-weight-effective {
  color: #0369a1;
  font-weight: 700;
}
.inventory-tree-node .tree-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  opacity: 0.7;
}
.inventory-tree-node .tree-actions:hover {
  opacity: 1;
}
.inventory-tree-node .tree-actions button {
  color: #6b7280 !important;
}
.inventory-tree-node .tree-actions button:hover {
  color: #374151 !important;
}

.tree-children {
  margin-left: 12px;
  padding-left: 6px;
  border-left: 1px solid #e5e7eb;
  margin-top: 2px;
  margin-bottom: 2px;
}

.inventory-tree-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  color: #6b7280;
}
.inventory-tree-loading .loading-spinner {
  width: 40px;
  height: 40px;
  border: 2px solid #e5e7eb;
  border-top-color: #6b7280;
  border-radius: 50%;
  animation: tree-spin 0.8s linear infinite;
}
.inventory-tree-loading p {
  margin-top: 16px;
  font-size: 14px;
}

@keyframes tree-spin {
  to {
    transform: rotate(360deg);
  }
}
.inventory-tree-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  text-align: center;
}
.inventory-tree-empty svg {
  color: #d1d5db;
  margin-bottom: 16px;
}
.inventory-tree-empty h3 {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
}
.inventory-tree-empty p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}
.inventory-tree-empty .mt-3 {
  margin-top: 16px;
}

.inventory-form .form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.inventory-form .form-control:disabled {
  background: #f3f4f6;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/Inventory/InventoryTree.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,gCAAA;AAAF;AAEE;;EAEE,gBAAA;AAAJ;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AADF;;AAKE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AAFJ;AAII;EACE,+BAAA;AAFN;AAME;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AAJJ;AAMI;EACE,WAAA;EACA,qBAAA;AAJN;AAQE;EACE,cAAA;EACA,cAAA;AANJ;AAQI;EACE,cAAA;AANN;AASI;EACE,cAAA;EACA,UAAA;AAPN;AAUI;EACE,cAAA;AARN;AAWI;EACE,cAAA;AATN;AAYI;EACE,cAAA;AAVN;AAcE;EACE,cAAA;AAZJ;AAeE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAlBJ;AAqBE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAnBJ;AAsBE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AApBJ;AAsBI;EACE,aAAA;AApBN;AAwBE;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;AAtBJ;AAyBE;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAvBJ;AA0BE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAzBJ;AA4BE;;EAEE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AA1BJ;AA6BE;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AA3BJ;AA8BE;EACA,aAAA;EACA,gBAAA;EACA,qCAAA;AA5BF;AA+BA;EACI,cAAA;EACA,gBAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AA9BJ;AAgCI;EACE,UAAA;AA9BN;AAiCI;EACE,yBAAA;AA/BN;AAiCM;EACE,yBAAA;AA/BR;;AAqCA;EACE,iBAAA;EACA,iBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AAlCF;;AAsCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AAnCF;AAqCE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;AAnCJ;AAsCE;EACE,gBAAA;EACA,eAAA;AApCJ;;AAwCA;EACE;IACE,yBAAA;EArCF;AACF;AAyCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAvCF;AAyCE;EACE,cAAA;EACA,mBAAA;AAvCJ;AA0CE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAxCJ;AA2CE;EACE,eAAA;EACA,cAAA;EACA,SAAA;AAzCJ;AA4CE;EACE,gBAAA;AA1CJ;;AAgDE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AA7CJ;AA+CI;EACE,mBAAA;EACA,mBAAA;AA7CN","sourcesContent":["// Inventory Tree - Clean minimalist design (like file explorer)\n.inventory-tree-toolbar {\n  padding: 12px 20px;\n  border-bottom: 1px solid #e5e7eb;\n\n  .tree-search-input,\n  input {\n    max-width: 280px;\n  }\n}\n\n.inventory-tree {\n  padding: 16px 20px;\n}\n\n.tree-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.inventory-tree-node {\n  .tree-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 4px 12px;\n    cursor: pointer;\n    transition: background 0.15s;\n    border-radius: 6px;\n    min-height: 32px;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.03);\n    }\n  }\n\n  .tree-toggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    flex-shrink: 0;\n    color: #6b7280;\n\n    .tree-spacer {\n      width: 16px;\n      display: inline-block;\n    }\n  }\n\n  .tree-icon {\n    flex-shrink: 0;\n    color: #6b7280;\n\n    &.tree-icon-folder {\n      color: #6b7280;\n    }\n\n    &.tree-icon-leaf {\n      color: #2563eb;\n      opacity: 1;\n    }\n\n    &.tree-icon-assembly {\n      color: #7c3aed;\n    }\n\n    &.tree-icon-model {\n      color: #0f766e;\n    }\n\n    &.tree-icon-final-product {\n      color: #d97706;\n    }\n  }\n\n  .tree-icon-assembly-input {\n    color: #a855f7;\n  }\n\n  .tree-model-badge {\n    margin-left: 8px;\n    font-size: 10px;\n    font-weight: 600;\n    font-family: monospace;\n    color: #0f766e;\n    background: rgba(15, 118, 110, 0.1);\n    padding: 2px 6px;\n    border-radius: 4px;\n  }\n\n  .tree-model-hub-badge {\n    margin-left: 8px;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #0f766e;\n    background: rgba(15, 118, 110, 0.12);\n    padding: 2px 6px;\n    border-radius: 4px;\n  }\n\n  .tree-final-product-badge {\n    margin-left: 8px;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #d97706;\n    background: rgba(217, 119, 6, 0.12);\n    padding: 2px 6px;\n    border-radius: 4px;\n  }\n\n  .tree-assembly-badge {\n    margin-left: 8px;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #7c3aed;\n    background: rgba(124, 58, 237, 0.1);\n    padding: 2px 6px;\n    border-radius: 4px;\n  }\n\n  .tree-label {\n    flex: 1;\n    min-width: 0;\n    font-size: 14px;\n    color: #111827;\n  }\n\n  .tree-composition {\n    margin-left: 4px;\n    font-size: 12px;\n    color: #9ca3af;\n  }\n\n  .tree-inputs-badge {\n    font-size: 11px;\n    color: #6b7280;\n    background: #f3f4f6;\n    padding: 2px 6px;\n    border-radius: 4px;\n    margin-left: 6px;\n  }\n\n  .tree-count {\n    font-size: 14px;\n    color: #6b7280;\n    margin-left: 4px;\n    min-width: 24px;\n    text-align: right;\n\n    &--empty {\n      opacity: 0.65;\n    }\n  }\n\n  .tree-machine-badges {\n    display: flex;\n    gap: 4px;\n    margin-left: 8px;\n    flex-shrink: 0;\n  }\n\n  .tree-machine-badge {\n    display: inline-flex;\n    align-items: center;\n    font-size: 11px;\n    font-family: monospace;\n    color: #3b82f6;\n    background: #eff6ff;\n    border: 1px solid #bfdbfe;\n    padding: 1px 6px;\n    border-radius: 4px;\n    white-space: nowrap;\n  }\n\n  .tree-qty-used {\n    font-size: 12px;\n    color: #9ca3af;\n    margin-left: 4px;\n    font-weight: 500;\n  }\n\n  .tree-row-meta {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-left: auto;\n    flex-shrink: 0;\n  }\n\n  .tree-weight,\n  .tree-cycle {\n    font-size: 0.72rem;\n    font-weight: 600;\n    color: #475569;\n    white-space: nowrap;\n    padding: 2px 8px;\n    background: #f1f5f9;\n    border-radius: 4px;\n    border: 1px solid #e2e8f0;\n  }\n\n  .tree-cycle {\n    color: #1d4ed8;\n    background: #eff6ff;\n    border-color: #bfdbfe;\n  }\n\n  .tree-weight-wastage {\n  opacity: 0.75;\n  font-size: 0.9em;\n  color: var(--m-danger-color, #dc3545);\n}\n\n.tree-weight-effective {\n    color: #0369a1;\n    font-weight: 700;\n  }\n\n  .tree-actions {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-left: auto;\n    opacity: 0.7;\n\n    &:hover {\n      opacity: 1;\n    }\n\n    button {\n      color: #6b7280 !important;\n\n      &:hover {\n        color: #374151 !important;\n      }\n    }\n  }\n}\n\n.tree-children {\n  margin-left: 12px;\n  padding-left: 6px;\n  border-left: 1px solid #e5e7eb;\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n\n// Loading\n.inventory-tree-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 20px;\n  color: #6b7280;\n\n  .loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 2px solid #e5e7eb;\n    border-top-color: #6b7280;\n    border-radius: 50%;\n    animation: tree-spin 0.8s linear infinite;\n  }\n\n  p {\n    margin-top: 16px;\n    font-size: 14px;\n  }\n}\n\n@keyframes tree-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n// Empty state\n.inventory-tree-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 24px;\n  text-align: center;\n\n  svg {\n    color: #d1d5db;\n    margin-bottom: 16px;\n  }\n\n  h3 {\n    font-size: 16px;\n    font-weight: 600;\n    color: #374151;\n    margin: 0 0 8px 0;\n  }\n\n  p {\n    font-size: 14px;\n    color: #6b7280;\n    margin: 0;\n  }\n\n  .mt-3 {\n    margin-top: 16px;\n  }\n}\n\n// Form in sidebar\n.inventory-form {\n  .form-control {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n\n    &:disabled {\n      background: #f3f4f6;\n      cursor: not-allowed;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
